import { useContext, createContext } from 'react';

export const AuthContext = createContext({ data: {}, user: {}, setUser: (user) => {} });

export function useAuthContextUser() {
    const userData = useContext(AuthContext);
    return userData?.user;
}

export function useAuthContext() {
    return useContext(AuthContext);
}

export function useSetAuthContextUser() {
    const { setUser } = useContext(AuthContext);
    return setUser;
}